<div class="editor">
  <div id="doka-container"></div>
</div>
